import { type JSX } from "react";
import { Navigate } from "react-router";
import { PERMISSIONS } from "@/shared/consts";
import { useAppSelector, useAuth } from "@/shared/hooks";
import { LOGIN_PAGE_ROUTE } from "@/shared/utils";
import { AccessDeniedPage } from "@/shared/components";

interface PermissionProtectedRouteProps {
  children: JSX.Element;
  requiredPermissions?: string[];
  requiredRoles?: string[];
}

export default function PermissionProtectedRoute({
  children,
  requiredPermissions = [],
  requiredRoles = [],
}: PermissionProtectedRouteProps) {
  const isAuth = useAppSelector((state) => state.auth.isAuth);
  const { hasAnyPermission, hasAnyRole } = useAuth();

  if (!isAuth) {
    return <Navigate to={LOGIN_PAGE_ROUTE} replace />;
  }

  if (requiredRoles.length > 0) {
    if (!hasAnyRole(requiredRoles)) {
      return <AccessDeniedPage />;
    }
  }

  if (requiredPermissions.length > 0) {
    if (!hasAnyPermission(requiredPermissions)) {
      return <AccessDeniedPage />;
    }
  }

  if (requiredRoles.length === 0 && requiredPermissions.length === 0) {
    if (!hasAnyPermission([PERMISSIONS.SELF.VIEW_PROFILE])) {
      return <AccessDeniedPage />;
    }
  }

  return children;
}

